(() => {
  const root = document.querySelector('[data-byob-inline]');
  if (!root || root.dataset.byobInitialized) return;
  root.dataset.byobInitialized = 'true';

  const CDN = root.dataset.cdnUrl;
  const IDS = { 2: root.dataset.bundle2, 3: root.dataset.bundle3 };
  const URLS = { 2: root.dataset.url2, 3: root.dataset.url3 };
  const VARIANTS = { 2: root.dataset.variant2, 3: root.dataset.variant3 };
  const DEFAULT_PACK = Number(root.dataset.defaultPack) || 2;
  // Kanonisk URL är byggarens egen sida (?pack=N) — aldrig produkt-URL:erna.
  // Produkt-URL:er i historik/bokmärken landar annars på den nakna bundle-PDP:n
  // utan pack-väljare vid hard refresh.
  const builderUrl = (pack) => {
    const url = new URL(window.location.href);
    url.searchParams.set('pack', String(pack));
    return url.pathname + url.search + url.hash;
  };
  const packFromUrl = () => {
    const p = Number(new URLSearchParams(window.location.search).get('pack'));
    return p === 2 || p === 3 ? p : null;
  };
  const container = root.querySelector('#bundling-app');
  const skeleton = root.querySelector('[data-byob-skeleton]');
  const fallback = root.querySelector('[data-byob-fallback]');
  const packLinks = [...root.querySelectorAll('[data-pack]')];

  let currentPack = null;
  let mounting = false;
  let remountCounter = 0;
  let queued = null;
  let failed = false;
  let retained = null;
  const isEnglish = !/^sv(?:-|$)/i.test(document.documentElement.lang || 'sv');
  const message = (sv, en) => isEnglish ? en : sv;
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.className = 'byob-mount-status';
  status.hidden = true;
  root.appendChild(status);
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.textContent = message('Försök igen', 'Try again');
  retry.hidden = true;
  root.appendChild(retry);
  retry.addEventListener('click', () => mount(packFromUrl() || currentPack || DEFAULT_PACK, 'replace'));
  function announce(text) { status.hidden = false; status.textContent = text; }
  function syncUrl(pack, mode) {
    if (mode === 'none') return;
    window.history[mode === 'push' ? 'pushState' : 'replaceState'](
      { ...(window.history.state || {}), byobPack: pack }, '', builderUrl(pack));
  }
  function cells() { return [...container.querySelectorAll('[role="gridcell"]')]; }
  function quantity(cell) { return Number(cell?.querySelector('input[type="number"]')?.value) || 0; }
  function identity(cell) {
    return cell.getAttribute('data-recharge-product-id') || cell.querySelector('[data-recharge-product-id]')?.getAttribute('data-recharge-product-id') || '';
  }
  function findCell(item) {
    return cells().find((cell) => item.id ? identity(cell) === item.id : cell.querySelector('.recharge-heading-h3')?.textContent.trim() === item.title);
  }

  const summaryButton = '.recharge-bundle-summary .recharge-button-primary, .recharge-bundle-summary-sidebar .recharge-button-primary, .recharge-bundle-summary-sticky-bar .recharge-button-primary';
  let addClickUntil = 0;
  function cartBusy() {
    const nativeBusy = [...container.querySelectorAll(summaryButton)].some((button) =>
      button.disabled && button.querySelector('[role="progressbar"][aria-busy="true"]'));
    // Cover the gap before Recharge renders its busy state; never hold a permanent local lock.
    return Boolean(pendingAdd) || addBlocked || nativeBusy || Date.now() < addClickUntil;
  }
  root.addEventListener('click', (event) => {
    const button = event.target.closest?.(summaryButton);
    if (!button) return;
    if (mounting || pendingAdd || addBlocked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (!button.disabled && !cartBusy()) {
      addClickUntil = Date.now() + 1000;
      status.hidden = true;
      cartLink.hidden = true;
      const attempt = { pack: currentPack, expectedVariant: VARIANTS[currentPack], selection: { items: readSelections(), oneTime: readOneTime() } };
      pendingAdd = attempt;
      // Missing callback (including bundle-ID service failure) cannot leave an
      // invisible spinner forever. An unresolved request is not safe to retry.
      attempt.timer = setTimeout(() => uncertainAdd(attempt), 25000);
    }
  }, true);

  // Recharge's documented hook replaces navigation, not native payload generation.
  // Fixed bundles currently call it even on HTTP errors; observe that response only.
  // https://docs.getrecharge.com/docs/bundling-widget-events
  let pendingAdd = null;
  let addBlocked = false;
  const cartLink = document.createElement('a');
  cartLink.href = (window.Shopify?.routes?.root || '/') + 'cart';
  cartLink.textContent = message('Kontrollera varukorgen', 'Check your cart');
  cartLink.hidden = true;
  root.appendChild(cartLink);
  const originalFetch = window.fetch;
  const priorAddCallback = window.RechargeBundle?.onAddToCart;

  function identifyBundleRequest(input, options, expectedVariant) {
    try {
      const url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
      if (url.origin !== window.location.origin || !/\/cart\/add(?:\.js)?$/.test(url.pathname)) return null;
      if ((options?.method || input?.method || 'GET').toUpperCase() !== 'POST') return null;
      const payload = JSON.parse(options?.body || 'null');
      if (!expectedVariant || !Array.isArray(payload?.items) || payload.items.length !== 1) return null;
      const parent = payload.items[0];
      return String(parent.id) === String(expectedVariant) ? (parent.properties?._rb_id || null) : null;
    } catch { return null; }
  }

  function closeMobileSummary() {
    if (!window.matchMedia?.('(max-width: 749px)').matches) return;
    const toggle = container.querySelector('.recharge-bundle-summary-sticky-bar .recharge-button-secondary');
    if (toggle && /dölj|hide/i.test(toggle.textContent || '')) toggle.click();
  }

  function revealCartError(target) {
    closeMobileSummary();
    const expectedText = status.textContent;
    // Completion replay can reopen Recharge's sheet after 300 ms. Close it once
    // more after that transition, then reveal the error outside the inert widget.
    setTimeout(() => {
      if (status.hidden || status.textContent !== expectedText) return;
      closeMobileSummary();
      setTimeout(() => {
        if (status.hidden || status.textContent !== expectedText) return;
        target.setAttribute('tabindex', '-1');
        target.scrollIntoView({ block: 'center', behavior: 'auto' });
        target.focus({ preventScroll: true });
      }, 100);
    }, 450);
  }

  function uncertainAdd(attempt) {
    if (pendingAdd !== attempt) return;
    addBlocked = true;
    closeMobileSummary();
    container.inert = true;
    cartLink.hidden = false;
    retry.hidden = true;
    status.setAttribute('role', 'alert');
    announce(message('Vi kunde inte bekräfta om din ritual lades till. Kontrollera varukorgen innan du försöker igen.', 'We could not confirm whether your ritual was added. Check your cart before trying again.'));
    revealCartError(cartLink);
  }

  async function recoverAdd(attempt) {
    if (pendingAdd !== attempt || attempt.recovering) return;
    attempt.recovering = true;
    clearTimeout(attempt.timer);
    retained = attempt.selection;
    failed = true;
    addClickUntil = 0;
    // Native network rejection leaves its loading flag set. Only this recovery
    // remount bypasses the busy guard; normal pack changes stay guarded.
    await mount(attempt.pack, 'replace', true);
    pendingAdd = null;
    addBlocked = false;
    if (!failed) {
      status.setAttribute('role', 'alert');
      announce(message('Din ritual kunde inte läggas till. Dina val är kvar. Försök igen.', 'Your ritual could not be added. Your selections are saved. Please try again.'));
      revealCartError(status);
    }
  }

  async function settleAdd(attempt) {
    if (pendingAdd !== attempt || attempt.settling) return;
    attempt.settling = true;
    clearTimeout(attempt.timer);
    if (attempt.ok) { window.location.assign(cartLink.href); return; }
    if (attempt.httpStatus >= 400 && attempt.httpStatus < 500) {
      await recoverAdd(attempt);
      return;
    }
    // Lost response / server failure: never repeat a possibly successful add.
    // Verify only the exact Recharge-generated bundle ID; leave all cart lines intact.
    if (!attempt.rbId) { uncertainAdd(attempt); return; }
    const controller = new AbortController();
    const verificationTimer = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await originalFetch.call(window, (window.Shopify?.routes?.root || '/') + 'cart.js', { cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('cart verification unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('invalid cart response');
      if (cart.items.some((item) => String(item.properties?._rb_id || '') === String(attempt.rbId))) {
        window.location.assign(cartLink.href);
      } else {
        // A missing line cannot exclude a delayed server commit after transport loss.
        uncertainAdd(attempt);
      }
    } catch { uncertainAdd(attempt); } finally { clearTimeout(verificationTimer); }
  }

  window.fetch = function (input, options) {
    const attempt = pendingAdd;
    const rbId = attempt && !attempt.requestClaimed && identifyBundleRequest(input, options, attempt.expectedVariant);
    if (!rbId) return originalFetch.apply(this, arguments);
    attempt.requestClaimed = true;
    attempt.rbId = rbId;
    // Do not intercept another add while handling this one; only observe our native request.
    return originalFetch.apply(this, arguments).then((response) => {
      attempt.ok = response.ok;
      attempt.httpStatus = response.status;
      return response;
    }, (error) => {
      setTimeout(() => settleAdd(attempt), 0);
      throw error;
    });
  };
  window.RechargeBundle = {
    ...(window.RechargeBundle || {}),
    onAddToCart() {
      if (!pendingAdd) { if (typeof priorAddCallback === 'function') priorAddCallback(); return; }
      const attempt = pendingAdd;
      // Recharge resets selections synchronously after this callback returns.
      setTimeout(() => settleAdd(attempt), 0);
    },
  };


  function setActivePill(pack) {
    packLinks.forEach((b) => {
      const on = Number(b.dataset.pack) === pack;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', String(on));
    });
  }

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  async function until(check, timeoutMs) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (check()) return true;
      await wait(100);
    }
    return Boolean(check());
  }
  function readSelections() {
    return cells().map((cell) => ({
      id: identity(cell),
      title: cell.querySelector('.recharge-heading-h3')?.textContent.trim() || '',
      qty: quantity(cell),
    })).filter((item) => item.qty > 0);
  }
  async function reapplySelections(items) {
    for (const item of items) {
      while (quantity(findCell(item)) < item.qty) {
        const cell = findCell(item);
        if (!cell) return false;
        const before = quantity(cell);
        const add = [...cell.querySelectorAll('button')].find((button) => /lägg till|add/i.test(button.textContent) && !button.disabled);
        const inc = [...cell.querySelectorAll('button, [role="button"], span')].find((control) =>
          /^(Öka|Increase|Increment)$/i.test((control.getAttribute('aria-label') || control.textContent || '').trim()) && !control.disabled);
        const control = before === 0 ? (add || inc) : inc;
        if (!control) return false;
        control.click();
        if (!await until(() => quantity(findCell(item)) > before, 2000)) return false;
      }
    }
    return true;
  }

  // --- Bevara köpalternativ (engång vs prenumeration) över pack-byte (CRO runda 2,
  // 2026-07-09) --- Recharge nollställer frekvensen till prenumeration vid
  // om-montering. Läs valet före re-mount (frekvens-selecten: option value "0" =
  // engångsköp) och driv nya widgetens select till "0" via native setter +
  // input/change — samma mekanik som caene-byob-frequency-toggle (verifierad live
  // 2026-07-01). Frekvens-toggle-UI:t syncar sig självt från select-värdet via sin
  // observer, och kortpriserna följer med via caene-byob-card-prices.
  const SELECT_SETTER = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value').set;

  function readOneTime() {
    const sels = container.querySelectorAll('select');
    for (const s of sels) {
      for (const o of s.options) { if (o.value === '0') return s.value === '0'; }
    }
    return false;
  }

  function driveOneTime() {
    let driven = false;
    container.querySelectorAll('select').forEach((s) => {
      if (![...s.options].some((o) => o.value === '0')) return;
      driven = true;
      SELECT_SETTER.call(s, '0');
      s.dispatchEvent(new Event('input', { bubbles: true }));
      s.dispatchEvent(new Event('change', { bubbles: true }));
    });
    return driven;
  }

  // Recharge owns selection, pricing, selling plans and cart submission.
  async function mount(pack, history, recoveringAdd = false) {
    if (pack !== 2 && pack !== 3) return;
    if (mounting) { queued = { pack, history }; return; }
    if (pack === currentPack && !failed) { syncUrl(pack, history === 'none' ? 'replace' : history); return; }
    if (!recoveringAdd && cartBusy()) {
      announce(message('Vänta tills din ritual har lagts i varukorgen innan du byter paket.', 'Please wait until your ritual has been added to the cart before switching packs.'));
      if (currentPack) syncUrl(currentPack, 'replace');
      return;
    }
    const keep = retained || { items: currentPack ? readSelections() : [], oneTime: currentPack ? readOneTime() : false };
    if (keep.items.reduce((sum, item) => sum + item.qty, 0) > pack) {
      announce(message('Ta bort en produkt ur din ritual innan du byter till 2-pack. Dina val är kvar.', 'Remove one product from your ritual before switching to a 2-pack. Your selections are unchanged.'));
      if (currentPack) syncUrl(currentPack, 'replace');
      return;
    }
    mounting = true;
    retained = keep;
    const anchorTop = currentPack ? root.getBoundingClientRect().top : null;
    retry.hidden = true;
    status.hidden = true;
    fallback.hidden = true;
    skeleton.style.display = '';
    root.setAttribute('aria-busy', 'true');
    setActivePill(pack);
    syncUrl(pack, history);
    try {
      // Keep user input out until Recharge has restored selections and purchase mode.
      // Programmatic native-control clicks still drive the widget during replay.
      container.inert = true;
      root.querySelectorAll('script[data-byob-widget]').forEach((script) => script.remove());
      container.innerHTML = '';
      window.StorefrontBundlingWidget = {
        containerId: container.id,
        externalProductId: Number(IDS[pack]),
        defaultLocale: undefined,
        translations: undefined,
      };
      const loaded = await new Promise((resolve) => {
        const script = document.createElement('script');
        let settled = false;
        const finish = (ok) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          script.onload = script.onerror = null;
          if (!ok) script.remove();
          resolve(ok);
        };
        const timer = setTimeout(() => finish(false), 12000);
        script.dataset.byobWidget = '1';
        script.src = CDN + (CDN.includes('?') ? '&' : '?') + 'remount=' + (++remountCounter);
        script.onload = () => finish(true);
        script.onerror = () => finish(false);
        root.appendChild(script);
      });
      if (!loaded || !await until(() => cells().some((cell) => cell.querySelector('.recharge-heading-h3')), 8000)) {
        throw new Error('widget unavailable');
      }
      if (!await reapplySelections(keep.items)) throw new Error('selection restoration incomplete');
      // Restore purchase mode independently of whether any products were selected.
      if (keep.oneTime && !await until(driveOneTime, 4000)) throw new Error('purchase mode unavailable');
      currentPack = pack;
      failed = false;
      retained = null;
    } catch (error) {
      failed = true;
      // A partial restoration must not expose a purchasable, incomplete replacement.
      container.innerHTML = '';
      announce(message('Byggaren kunde inte laddas. Försök igen för att återställa dina val.', 'The builder could not load. Try again to restore your selections.'));
      retry.hidden = false;
      if (URLS[pack]) {
        const url = new URL(URLS[pack], window.location.href);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.searchParams.set('fallback', '1');
        fallback.href = url.href;
        fallback.hidden = false;
      }
    } finally {
      container.inert = false;
      skeleton.style.display = 'none';
      root.setAttribute('aria-busy', 'false');
      if (anchorTop !== null) {
        const delta = root.getBoundingClientRect().top - anchorTop;
        if (delta) window.scrollBy(0, delta);
      }
      mounting = false;
      const next = queued;
      queued = null;
      if (next) mount(next.pack, next.history);
    }
  }

  // Pills are real <a> links to the product URLs; intercept for the soft-swap.
  packLinks.forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      mount(Number(b.dataset.pack), 'push');
    })
  );

  // Back/Forward between packs we pushed — re-mount without writing history.
  window.addEventListener('popstate', (e) => {
    const pack = e.state && e.state.byobPack ? Number(e.state.byobPack) : packFromUrl() || DEFAULT_PACK;
    mount(pack, 'none');
  });

  mount(packFromUrl() || DEFAULT_PACK, 'replace');
})();
